export default __webpack_public_path__ + "8af06288f4bbd81ae71b0d89e06e36dd.png";